module.exports = __webpack_public_path__ + "img/blue_111.8b49da14.png";